import * as React from 'react';
import { Box, Typography, Paper, Chip } from '@mui/material';
import changeLogData from './changelog.json';
import InformationalLayout from './InformationalLayout';

function ChangeLog() {
    return (
        <InformationalLayout
            title="Updates & Changelog"
            subtitle="Stay up to date with the latest CueMeUp features and improvements"
            maxWidth="md"
        >

            {/* Updates List */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {changeLogData.updates.map((update, index) => (
                    <Paper
                        key={update.version}
                        elevation={update.isLatest ? 3 : 2}
                        sx={{
                            p: 4,
                            backgroundColor: update.isLatest ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.9)'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                            <Typography variant="h5" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                                Version {update.version}
                            </Typography>
                            {update.isLatest && <Chip label="Latest" color="primary" size="small" />}
                        </Box>
                        <Typography variant="body2" sx={{ color: '#6c757d', mb: 3 }}>
                            {update.date}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            {update.features.length > 0 && (
                                <Box>
                                    <Typography variant="h6" sx={{ color: '#2c3e50', mb: 1 }}>
                                        ✨ New Features
                                    </Typography>
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        {update.features.map((feature, featureIndex) => (
                                            <li key={featureIndex}>{feature}</li>
                                        ))}
                                    </ul>
                                </Box>
                            )}
                            {update.improvements.length > 0 && (
                                <Box>
                                    <Typography variant="h6" sx={{ color: '#2c3e50', mb: 1 }}>
                                        🔧 Improvements
                                    </Typography>
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        {update.improvements.map((improvement, improvementIndex) => (
                                            <li key={improvementIndex}>{improvement}</li>
                                        ))}
                                    </ul>
                                </Box>
                            )}
                            {update.bugFixes.length > 0 && (
                                <Box>
                                    <Typography variant="h6" sx={{ color: '#2c3e50', mb: 1 }}>
                                        🐛 Bug Fixes
                                    </Typography>
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        {update.bugFixes.map((bugFix, bugFixIndex) => (
                                            <li key={bugFixIndex}>{bugFix}</li>
                                        ))}
                                    </ul>
                                </Box>
                            )}
                            {update.version === '1.0.0' && (
                                <Box>
                                    <Typography variant="h6" sx={{ color: '#2c3e50', mb: 1 }}>
                                        🎉 Initial Release
                                    </Typography>
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        {update.features.map((feature, featureIndex) => (
                                            <li key={featureIndex}>{feature}</li>
                                        ))}
                                    </ul>
                                </Box>
                            )}
                        </Box>
                    </Paper>
                ))}
            </Box>
        </InformationalLayout>
    );
}

export default ChangeLog;
